// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@guestsupply/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsHeader";
import { css } from "styled-components";

headerStyles.wrongCustomerGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
    `,
};

headerStyles.wrongCustomerWarning = {
    css: css`
        max-width: unset;
    `,
};
